<div class="status-page">
  <div class="status-header">
    <div>
      <h1>Zetrix status</h1>
      <p>Health of the platform's blockchain integration.</p>
    </div>
    <button class="refresh-btn" (click)="load()" [disabled]="isLoading()">
      <span class="material-icons">refresh</span>
      Refresh
    </button>
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading() && !status()) {
    <p class="hint">Loading...</p>
  } @else if (status(); as s) {
    <div class="health-card">
      <div class="health-card__top">
        <span class="health-pill health-pill--{{ healthAccent }}">{{ healthLabel }}</span>
        <span class="health-detail">{{ s.detail }}</span>
      </div>

      <dl class="status-grid">
        <div class="status-field">
          <dt>Enabled</dt>
          <dd>{{ s.enabled ? 'Yes' : 'No' }}</dd>
        </div>
        <div class="status-field">
          <dt>Configured (can write)</dt>
          <dd>{{ s.canWrite ? 'Yes' : 'No' }}</dd>
        </div>
        <div class="status-field">
          <dt>Network</dt>
          <dd>{{ s.network }}</dd>
        </div>
        <div class="status-field">
          <dt>Block height</dt>
          <dd>{{ s.blockHeight ?? '—' }}</dd>
        </div>
        <div class="status-field status-field--wide">
          <dt>Base URL</dt>
          <dd><code>{{ s.baseUrl }}</code></dd>
        </div>
      </dl>
    </div>
  }
</div>
